var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64275 7.5553C4.71157 7.28925 3.70934 7.54896 3.02454 8.23375L2.24843 9.00986L11.6765 16.5523L17.3334 10.8955L5.64275 7.5553ZM5.06207 19.1891C4.18777 19.0143 3.28394 19.288 2.65347 19.9184L2.24841 20.3235L5.54824 22.6805L8.37667 19.8521L5.06207 19.1891Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7104 4.51818C24.4246 3.80396 25.4811 3.55457 26.4393 3.87398L26.7555 3.97939C27.3528 4.17846 27.8214 4.64709 28.0205 5.2443L28.1259 5.56053C28.4453 6.51875 28.1959 7.5752 27.4817 8.28942L21.1046 14.6665L24.4447 26.357C24.7108 27.2882 24.4511 28.2905 23.7663 28.9752L22.9902 29.7514L15.4478 20.3233L12.1479 23.6232L12.8108 26.9377C12.9857 27.812 12.712 28.7158 12.0816 29.3463L11.6765 29.7513L9.31952 26.4516H9.31945L7.71668 24.2832L5.54822 22.6804L23.7104 4.51818Z",
    fill: "#FAB215"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.652516290470e9783fbf7271835d5b60.svg";
export { ForwardRef as ReactComponent };